import { createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import { LoginDialog } from "../Login/LoginDialog";
import { Navbar } from "../Navbar";
import { RegisterDialog } from "../Register/RegisterDialog";
import { useHistory, useLocation } from "react-router";

const useStyles = makeStyles((theme) =>
    createStyles({
        navbar: {
            position: "relative",
            zIndex: 1000,
        },
    })
);

export const HEADER_DESKTOP_H = 100;

export function Header(props: any) {
    const classes = useStyles();
    const [openDialog, setOpenDialog] = React.useState(false);
    const [openRegister, setOpenRegister] = React.useState(false);
    const history = useHistory();

    //OPEN / CLOSE LOGIN MODAL
    const handleClickOpenLoginDialog = () => {
        setOpenRegister(false);
        setOpenDialog(true);
    };

    const handleCloseLoginDialog = () => {
        setOpenDialog(false);
    };

    //OPENT / CLOSE REGISTER MODAL

    const handleClickOpenRegister = () => {
        setOpenRegister(true);
        setOpenDialog(false);
    };

    const handleCloseRegister = () => {
        setOpenRegister(false);
    };
    return (
        <div className={classes.navbar}>
            <Navbar
                handleClickOpenLoginDialog={handleClickOpenLoginDialog}
                setDeal={props.setDeal}
                deal={props.deal}
                handleClickOpenRegister={handleClickOpenRegister}
            />
            <LoginDialog
                open={openDialog}
                handleClose={handleCloseLoginDialog}
                handleClickOpenRegister={handleClickOpenRegister}
                redirectPath={history.location.pathname + history.location.search}
            />
            <RegisterDialog
                open={openRegister}
                handleClose={handleCloseRegister}
                handleOpenLoginDialog={handleClickOpenLoginDialog}
                redirectPath={history.location.pathname + history.location.search}
            />
        </div>
    );
}
